import {createContext, useContext, useEffect, useReducer} from "react";
import {countInCartItems} from "./localStorageRepository";

const HeaderContext = createContext(undefined);

export const HeaderProvider = ({ children }) => {
  const [headerState, headerDispatch] = useReducer(reducer, null, initializer);

  useEffect(() => {
    organismsInitHeaderFooterGetApi()
      .then(resJson => {
        headerDispatch({ type: "UPDATE_PRODUCT_CATEGORIES", payload: {productCategories: resJson.productCategories} });
      })
      .catch(err => console.error(err));
  }, []);

  return (
    <HeaderContext.Provider value={{ headerState, headerDispatch }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => useContext(HeaderContext);

const reducer = (state, {type, payload}) => {
  switch (type) {
    case "ADD_TO_CART": {
      const {hasNewItem} = payload;
      if (hasNewItem) return {...state, cartCount: state.cartCount + 1};
      return state;
    }
    case "REMOVE_FROM_CART": {
      return {...state, cartCount: state.cartCount - 1};
    }
    case "UPDATE_CART": {
      const {itemQuantity} = payload;
      return {...state, cartCount: itemQuantity};
    }
    case "UPDATE_PRODUCT_CATEGORIES": {
      const {productCategories} = payload;
      return {...state, productCategories: productCategories};
    }
    default: throw new Error("Unknown header context action: " + type);
  }
};

const initializer = () => {
  return {
    cartCount: countInCartItems(),
    productCategories: null,
  };
};

const organismsInitHeaderFooterGetApi = async () => {
  const organismsInitHeaderFooterGetApiRes = await fetch("/api/organisms/init_header_footer");

  if (!organismsInitHeaderFooterGetApiRes.ok) {
    throw new Response("Not Found", { status: 404 });
  }

  return await organismsInitHeaderFooterGetApiRes.json();
};
